export const createVideo = (element, videoId, width, height, id = null) => {
  const video = document.createElement('div');
  video.setAttribute('data-controller', 'video');
  video.setAttribute('data-video-video-id-value', videoId);
  video.setAttribute('data-video-target', 'player');
  video.setAttribute('data-video-width-value', width);
  video.setAttribute('data-video-height-value', height);
  video.classList.add('flex-grow-1');

  if (id) {
    video.setAttribute('id', id);
  }

  return video;
};
